import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Router} from '@angular/router';
import {ActivatedRoute, Params, Data} from '@angular/router';
import {environment as env} from '../../../environments/environment';
import {Page} from '../../models/page';

@Component({
  selector: 'app-otherpage',
  templateUrl: './otherpage.component.html',
  styleUrls: ['./otherpage.component.css']
})
export class OtherpageComponent implements OnInit {
  page:Page;
  imgurl:string; 
  slug:string;
  constructor(private http:HttpClient, private router:Router, private route:ActivatedRoute, ) { 
    this.imgurl =  env.imgurl
  }


  ngOnInit(): void { 
    window.scroll(0,0);

    this.route.params.subscribe(
      (params:Params) => {
        if(params['slug']){
          this.slug = params['slug'];
          this.http.get(env.apiurl+'page/'+this.slug).subscribe(data=>{
            this.page = data['data'];
            console.log(this.page);
          });
        }
      }
    );
   }

}
